module.exports = __webpack_public_path__ + "img/TR.ffeaeaa6.svg";